module.exports = __webpack_public_path__ + "img/paper_texture.19c98bde.png";